import { createSlice } from '@reduxjs/toolkit';
import { RevenuePercentageReducer } from '../../reducers/RevenuePercentageReducer';
import { IRevenuePercentage } from '../../../forms-v2/components/dynamic-fields/pi_revenue_percentage/IRevenuePercentage';

const initialState: IRevenuePercentage = {
	list: [],
	isStart: true,
};

export const revenuePercentageSlice = createSlice({
	name: 'revenue-percentage',
	initialState,
	reducers: RevenuePercentageReducer,
});

export const { mergeListActivities, resetListActivities } =
	revenuePercentageSlice.actions;

export default revenuePercentageSlice.reducer;
